module.exports = __webpack_public_path__ + "img/straightfence.4259f415.webp";